<template>
  <div>
    <div v-for="(obj, index) in intervention.types" :key="index">
      <b>{{ obj.type.name }}</b
      >: {{ obj.count }}<br />
    </div>
  </div>
</template>

<script>
export default {
  name: "Intervention",
  props: {
    intervention: {
      type: Object,
    },
  },
}
</script>
